export default __webpack_public_path__ + "static/intro_automate-9d11ff0ab709eb69078f2093d6e28c58.png";